import React, { useMemo, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
// redux
import { useSelector, useDispatch } from 'react-redux';
import { selectors as loadSelectors } from 'state/loads';
import { selectors as orderSelectors } from 'state/order';
import loadsActions from 'state/loads/actionCreators';
// styles
import styled, { css } from 'styled-components';
import { gridSizes } from 'utils/style';
// components
import LoadInputs from './loadInputs';
import AddLoad from './addLoad';

const LoadsForm = ({ className, shipmentKey, isMultiRoute }) => {
  const dispatch = useDispatch();

  const loads = useSelector((state) =>
    loadSelectors.getLoads(state, shipmentKey)
  );
  const isEditing = useSelector(orderSelectors.getIsEditing);

  const hasMultipleLoads = useMemo(() => loads?.length > 1, [loads]);

  const createLoad = useCallback(() => {
    dispatch(loadsActions.createLoad({ shipmentKey }));
  }, [dispatch, shipmentKey]);

  useEffect(() => {
    if (loads.length === 0) {
      createLoad();
    }
  }, [loads, createLoad]);

  return (
    <div className={className} data-testid="load-data">
      {loads.map((loadKey, i) => (
        <LoadInputs
          key={loadKey}
          shipmentKey={shipmentKey}
          loadKey={loadKey}
          hasMultipleLoads={hasMultipleLoads}
          loadNumber={i + 1}
        />
      ))}
      {!isEditing && <AddLoad shipmentKey={shipmentKey} />}
    </div>
  );
};

LoadsForm.propTypes = {
  className: PropTypes.string,
  shipmentKey: PropTypes.string.isRequired,
  isMultiRoute: PropTypes.bool,
};

LoadsForm.defaultProps = {
  isMultiRoute: false,
};

export default styled(LoadsForm)`
  margin-bottom: ${gridSizes('M')};
  ${(props) =>
    !!props.isMultiRoute &&
    css`
      padding-top: 16px;
      border-left: 2px solid var(--grey300);
      margin-left: 8px;
      padding-left: 16px;
    `}
`;
